import { TRANSLATE_LANGUAGES } from '@/types'
import { computed } from 'vue'
import { useGlobalState } from './use-global-store'

export function useTranslate() {
    const { transLang: mode, updateTranslateLang } = useGlobalState();

    const isOrigin = computed(() => {
        return mode.value === TRANSLATE_LANGUAGES.NONE
    })

    const isTranslateToEnglish = computed(() => {
        return mode.value === TRANSLATE_LANGUAGES.ENGLISH
    })

    const isTranslateToJapan = computed(() => {
        return mode.value === TRANSLATE_LANGUAGES.JAPANESE
    })

    const isTranslateToChinese = computed(() => {
        return mode.value === TRANSLATE_LANGUAGES.CHINESE
    })

    function change(modeValue: TRANSLATE_LANGUAGES) {
        if (!modeValue) return
        updateTranslateLang(modeValue)
    }

    return {
        mode,
        isOrigin,
        isTranslateToEnglish,
        isTranslateToJapan,
        isTranslateToChinese,
        change,
    }
}
